export const OFFERS = {
    STANDARD: 'Standard',
    PRO: 'Pro',
    ULTIME: 'Ultime'
};